import React from "react";
import "./HealthTwoProducts.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useNavigate } from "react-router-dom";

const categories = [
  "Cardiology",
  "Neurology",
  "Pediatrics",
  "Gastroenterology",
  "Nephrology",
  "Gynecology",
  "Orthopedics",
  "Urology",
];

const HealthTwoProducts = () => {
  const navigate = useNavigate();

  const { documents } = useCollection("products", [
    "topSellingProducts",
    "==",
    true,
  ]);

  const trendingProducts = documents
    ? documents.filter((product) => product.status === "active").slice(0, 8)
    : [];

  return (
    <section className="health-two-trending-products">
      <div className="header">
        <h2 className="health-two-section-heading">
          Trending products for you!
        </h2>
        <button className="see-all" onClick={() => navigate("/products-two")}>
          SEE ALL PRODUCTS →
        </button>
      </div>

      <div className="categories">
        {categories.map((cat, i) => (
          <button key={i} className="category">
            {cat}
          </button>
        ))}
      </div>

      <div className="products-grid">
        {trendingProducts.map((product, i) => (
          <div
            className="product-card"
            key={i}
            onClick={() => navigate(`/product-details-two/${product.id}`)}
          >
            {product.offer && <span className="discount">{product.offer}</span>}

            <img src={product.images[0]} alt={product.name} />

            <div className="details">
              <h4>{product.name}</h4>
              <p className="category">{product.category}</p>

              <div className="bottom-row">
                <div className="price">
                  <span className="new">₹{product.price}</span>
                  {product.originalPrice && (
                    <span className="old">₹{product.originalPrice}</span>
                  )}
                </div>
                <button className="add-to-cart">+ Add to Cart</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HealthTwoProducts;
